module.exports = __webpack_public_path__ + "5affcebfdd86d4300a77387cd46dcd96.jpg";